(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5879],{

/***/ 28790:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/breaking-news",
      function () {
        return __webpack_require__(4226);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/modules/Card.module.scss
var Card_module = __webpack_require__(76136);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Svg/Remove.js
var Remove = __webpack_require__(6607);
;// CONCATENATED MODULE: ./components/Svg/SendOutline.js

function Send() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18.038 1.038l-9.336 9.336M18.038 1.038l-5.94 16.975-3.396-7.639L1.063 6.98l16.975-5.941z",
            stroke: "#BDBDBD",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}

;// CONCATENATED MODULE: ./components/Svg/Card/ChevronRight.js

function ChevronRight(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#3E20FF";
    var _stroke;
    var stroke = (_stroke = props.stroke) !== null && _stroke !== void 0 ? _stroke : "#3E20FF";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "14.49",
                cy: "13.538",
                r: "13",
                stroke: stroke
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M17.53 12.123l1.413 1.415-5.656 5.657-1.415-1.415z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M11.871 9.295l1.414-1.414 5.657 5.657-1.414 1.414z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./helpers/getCharacters.js
var getCharacters = __webpack_require__(51091);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
// EXTERNAL MODULE: ./utils/tag-remove.js
var tag_remove = __webpack_require__(92131);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
;// CONCATENATED MODULE: ./helpers/date.js
var formatDate = function(date) {
    var formattedDate = new Date(date);
    var hours = formattedDate.getHours();
    var minutes = formattedDate.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var timePart = hours + ":" + minutes + " " + ampm;
    return "".concat(formattedDate.getDate(), "/").concat(formattedDate.getMonth() + 1, "/").concat(formattedDate.getFullYear(), ", ").concat(timePart);
};
/* harmony default export */ var date = (formatDate);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./components/Svg/Eye.js
var Eye = __webpack_require__(17485);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./store/company/index.js
var company = __webpack_require__(3383);
// EXTERNAL MODULE: ./store/product.js
var product = __webpack_require__(92221);
;// CONCATENATED MODULE: ./components/Story/EditingService.js











var EditingService = function(param) {
    var id = param.id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var data = (0,es/* useSelector */.v9)(product/* productsSelector */.eV).data;
    var ref = (0,es/* useSelector */.v9)(company/* companySelector */.yX), companyState = ref.data;
    var ref1 = (0,react.useState)({}), companyData = ref1[0], setCompanyData = ref1[1];
    var ref2 = (0,react.useState)({}), paymentData = ref2[0], setPaymentData = ref2[1];
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.proEdit) {
            var _proEdit = data.proEdit, prices = _proEdit.prices, product = (0,_object_without_properties/* default */.Z)(_proEdit, [
                "prices"
            ]);
            setPaymentData({
                prices: prices,
                product: product
            });
        }
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        setCompanyData(companyState);
    }, [
        companyData
    ]);
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, priceId, price;
            return (0,tslib_es6.__generator)(this, function(_state) {
                e.preventDefault();
                priceId = companyData.plan.type === "free" ? "price_1JQ7niBW954orhDfvp6JKtRg" : "price_1JQ7niBW954orhDfgdPy3djs";
                price = (ref = paymentData.prices) === null || ref === void 0 ? void 0 : ref.find(function(price) {
                    return price.id === priceId;
                });
                dispatch((0,product/* setPaymentDetails */.sM)({
                    product: paymentData.product,
                    price: price,
                    storyId: id
                }));
                router.push({
                    pathname: "/payments"
                });
                return [
                    2
                ];
            });
        });
        return function handleClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: [
            (Card_module_default()).card__status,
            (Card_module_default())["card__status--request-editing"], 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye/* default */.Z, {}),
            "Request\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#",
                onClick: handleClick,
                children: "editing service"
            })
        ]
    });
};
/* harmony default export */ var Story_EditingService = (EditingService);

// EXTERNAL MODULE: ./components/Svg/NewsAlertLogo.js
var NewsAlertLogo = __webpack_require__(99652);
;// CONCATENATED MODULE: ./components/Card.js













var CardOverlay = function(param) {
    var link = param.link;
    if (!link) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (Card_module_default()).overlayLink
        })
    });
};
var CardRemove = function(param) {
    var onRemove = param.onRemove, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (Card_module_default()).close,
        onClick: function() {
            return onRemove(id);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {
            fill: "#C4C4C4",
            fillCross: "#FFF"
        })
    });
};
var CardActionOpen = function(param) {
    var link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (Card_module_default()).action,
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
    });
};
var CardApproval = function(param) {
    var status = param.status, onApprove = param.onApprove, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        theme: "primary",
        classes: [
            (Card_module_default()).button
        ],
        onClick: function() {
            return onApprove(id);
        },
        title: status === "pinned" ? "UNPIN" : "PIN"
    });
};
var CardTitle = function(param) {
    var linkOverlay = param.linkOverlay, title = param.title, link = param.link;
    if (linkOverlay) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
            variant: "h3",
            className: [
                "pb-xs",
                (Card_module_default()).title
            ].join(" "),
            children: (0,getCharacters/* default */.Z)(title, 50)
        });
    }
    if (link) {
        // External link
        if (link.includes("http")) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                variant: "h3",
                Tag: "a",
                href: link,
                target: "_blank",
                rel: "noreferrer",
                className: [
                    "pb-xs",
                    (Card_module_default()).title
                ].join(" "),
                children: (0,getCharacters/* default */.Z)(title, 50)
            });
        }
        // Internal link
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                    variant: "h3",
                    Tag: "div",
                    className: [
                        "pb-xs",
                        (Card_module_default()).title
                    ].join(" "),
                    children: (0,getCharacters/* default */.Z)(title, 50)
                })
            })
        });
    }
    return null;
};
var CardBody = function(param) {
    var body = param.body, _limit = param.limit, limit = _limit === void 0 ? 300 : _limit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
        variant: "body",
        className: (Card_module_default()).body,
        dangerouslySetInnerHTML: {
            __html: (0,getCharacters/* default */.Z)((0,tag_remove/* default */.Z)(body), limit)
        }
    });
};
var CardCta = function(param) {
    var status = param.status, cta = param.cta, link = param.link, onApprove = param.onApprove, id = param.id;
    if (link.includes("http")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Card_module_default()).wrapperCta,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: [
                        "mt-xs",
                        (Card_module_default()).cta
                    ].join(" "),
                    href: link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: cta
                }),
                onApprove && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardApproval, {
                    status: status,
                    onApprove: onApprove,
                    id: id
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Card_module_default()).wrapperCta,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: [
                        "mt-xs",
                        (Card_module_default()).cta
                    ].join(" "),
                    children: cta
                })
            }),
            onApprove && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardApproval, {
                status: status,
                onApprove: onApprove,
                id: id
            })
        ]
    });
};
var Card = function(param) {
    var id = param.id, pretitle = param.pretitle, title = param.title, body = param.body, publishedAt = param.publishedAt, status = param.status, cta = param.cta, link = param.link, linkOverlay = param.linkOverlay, onRemove = param.onRemove, _story = param.story, story = _story === void 0 ? false : _story, _onApprove = param.onApprove, onApprove = _onApprove === void 0 ? null : _onApprove, _limit = param.limit, limit = _limit === void 0 ? 300 : _limit, _alert = param.alert, alert = _alert === void 0 ? false : _alert, _author = param.author, author = _author === void 0 ? null : _author, _feed = param.feed, feed = _feed === void 0 ? false : _feed;
    var isNonDefaultStatus = status && status !== "publish";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (Card_module_default()).card
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    "p-card",
                    (Card_module_default()).cardWrapper
                ].join(" "),
                children: [
                    isNonDefaultStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            (Card_module_default()).card__status,
                            status === "new" ? (Card_module_default())["card__status--new"] : "", 
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: status.toUpperCase()
                        })
                    }),
                    linkOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardOverlay, {
                        link: link
                    }),
                    onRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRemove, {
                        onRemove: onRemove,
                        id: id
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionOpen, {
                        link: link
                    }),
                    alert && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            "mb-xs",
                            (Card_module_default()).logo
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsAlertLogo/* default */.Z, {})
                    }),
                    pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                        variant: "caption",
                        className: "mb-s",
                        children: pretitle
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                        title: title,
                        linkOverlay: linkOverlay,
                        link: link
                    }),
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody, {
                        body: body,
                        limit: limit
                    }),
                    cta && link && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCta, {
                        cta: cta,
                        link: link,
                        onApprove: onApprove,
                        id: id,
                        status: status
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Card_module_default()).card__actions,
                children: [
                    publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (Card_module_default()).card__status,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Send, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Published: ",
                                    date(publishedAt),
                                    feed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ", by ",
                                            alert ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://newspage.co.uk/about-us/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (Card_module_default()).authorLink,
                                                    children: "Dominic Hiatt"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/".concat(author.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (Card_module_default()).authorLink,
                                                    children: author.name
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    story && /*#__PURE__*/ (0,jsx_runtime.jsx)(Story_EditingService, {
                        id: id
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Card = (Card);


/***/ }),

/***/ 93086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_modules_newsStory_Index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73736);
/* harmony import */ var styles_modules_newsStory_Index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsStory_Index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var NotFound = function(param) {
    var text = param.text, _button = param.button, button = _button === void 0 ? null : _button;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (styles_modules_newsStory_Index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().noStoryBlock),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: text
                })
            }),
            button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_modules_newsStory_Index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().buttonWrapper),
                children: button
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotFound);


/***/ }),

/***/ 87878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowDown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ArrowDown() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 5l5 5 5-5",
            stroke: "#2300FF",
            strokeWidth: "2"
        })
    });
}


/***/ }),

/***/ 17485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Eye; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Eye(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1418 916",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fill,
                d: "M708.531 676.277c120.483 0 218.154-97.671 218.154-218.154 0-120.483-97.671-218.154-218.154-218.154-120.483 0-218.154 97.671-218.154 218.154 0 120.483 97.671 218.154 218.154 218.154z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fill,
                d: "M1395.29 397.695C1227.6 195.057 973.767 0 708.516 0 443.214 0 189.318 195.193 21.7404 397.695c-28.9872 35.013-28.9872 85.843 0 120.857 42.131 50.911 130.4556 149.19 248.4226 235.061 297.096 216.277 578.956 216.755 876.707 0 117.97-85.871 206.29-184.15 248.42-235.061 28.9-34.946 29.05-85.729 0-120.857zM708.516 152.708c168.415 0 305.414 137 305.414 305.415 0 168.415-136.999 305.416-305.414 305.416S403.101 626.538 403.101 458.123s137-305.415 305.415-305.415z"
            })
        ]
    });
}


/***/ }),

/***/ 99652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsAlertLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function NewsAlertLogo(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "146",
        height: "32",
        viewBox: "0 0 146 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7 7.5H5.5V9V22.4815V26V28.73L7.80434 27.2661L12.9746 23.9815H25H26.5V22.4815V9V7.5H25H7Z",
                stroke: "#3E20FF",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M51.3 9V17.5L44.34 9H41.66V23H44.86V14.5L51.84 23H54.5V9H51.3ZM68.1323 17.66C68.1323 14.2 65.6923 12.08 62.5323 12.08C59.2523 12.08 56.7923 14.4 56.7923 17.62C56.7923 20.82 59.2123 23.16 62.9323 23.16C64.8723 23.16 66.3723 22.56 67.3723 21.42L65.7123 19.62C64.9723 20.32 64.1523 20.66 63.0123 20.66C61.3723 20.66 60.2323 19.84 59.9323 18.5H68.0723C68.0923 18.24 68.1323 17.9 68.1323 17.66ZM62.5523 14.44C63.9523 14.44 64.9723 15.32 65.1923 16.68H59.8923C60.1123 15.3 61.1323 14.44 62.5523 14.44ZM84.5342 12.24L81.9142 19.52L79.3542 12.24H76.7142L74.0742 19.52L71.5342 12.24H68.5942L72.4742 23H75.4742L77.9742 16.32L80.3942 23H83.3942L87.2942 12.24H84.5342ZM92.2084 23.16C95.4284 23.16 97.2884 21.74 97.2884 19.74C97.2884 15.5 90.7884 17.28 90.7884 15.44C90.7884 14.88 91.3884 14.44 92.7884 14.44C93.7684 14.44 94.8284 14.64 95.8884 15.24L96.9284 13.02C95.9084 12.42 94.2684 12.08 92.7884 12.08C89.6484 12.08 87.8084 13.52 87.8084 15.56C87.8084 19.86 94.3084 18.06 94.3084 19.82C94.3084 20.42 93.7684 20.8 92.3284 20.8C91.0084 20.8 89.5484 20.38 88.5884 19.76L87.5484 22C88.5484 22.66 90.3884 23.16 92.2084 23.16ZM110.513 23H112.073L105.673 9H104.213L97.8134 23H99.3534L101.033 19.26H108.833L110.513 23ZM101.573 18.06L104.933 10.54L108.293 18.06H101.573ZM114.089 23H115.509V8.16H114.089V23ZM128.64 17.74C128.64 14.58 126.5 12.4 123.54 12.4C120.58 12.4 118.4 14.62 118.4 17.74C118.4 20.86 120.64 23.1 123.92 23.1C125.58 23.1 127.04 22.5 127.98 21.38L127.18 20.46C126.38 21.38 125.24 21.84 123.96 21.84C121.66 21.84 119.98 20.38 119.82 18.18H128.62C128.62 18.02 128.64 17.86 128.64 17.74ZM123.54 13.62C125.6 13.62 127.1 15.06 127.28 17.12H119.82C120 15.06 121.5 13.62 123.54 13.62ZM132.891 14.54V12.48H131.531V23H132.951V17.64C132.951 15.16 134.291 13.76 136.491 13.76C136.591 13.76 136.711 13.78 136.831 13.78V12.4C134.891 12.4 133.551 13.14 132.891 14.54ZM144.891 21.34C144.491 21.7 143.911 21.88 143.331 21.88C142.151 21.88 141.511 21.2 141.511 19.96V13.68H144.711V12.48H141.511V10.18H140.091V12.48H138.211V13.68H140.091V20.04C140.091 21.98 141.191 23.1 143.171 23.1C143.991 23.1 144.831 22.86 145.391 22.36L144.891 21.34Z",
                fill: "#232735"
            })
        ]
    }));
}


/***/ }),

/***/ 6607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Remove; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Remove(props) {
    var fill = props.fill ? props.fill : "#f44336";
    var fillCross = props.fillCross ? props.fillCross : "#fafafa";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fill,
                d: "M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: fillCross,
                d: "M350.3 320.1a21.3 21.3 0 11-30.2 30.2L256 286.2l-64.1 64a21.3 21.3 0 01-30.2 0 21.3 21.3 0 010-30l64.1-64.2-64-64.1a21.3 21.3 0 1130-30.2l64.2 64.1 64.1-64a21.3 21.3 0 1130.2 30L286.2 256zm0 0"
            })
        ]
    });
}


/***/ }),

/***/ 23775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61176);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var Typo = function(props) {
    var variant = props.variant, Tag = props.Tag, color = props.color, className = props.className, children = props.children, font = props.font;
    if (!Tag) {
        switch(variant){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
            case "blockquote":
                Tag = variant;
                break;
            default:
                Tag = "p";
        }
    }
    if (!variant) variant = "body";
    var classes = [
        (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().typo),
        variant ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(variant)] : null,
        color ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(color)] : null,
        font ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(font)] : null,
        className ? className : null, 
    ].filter(Boolean).join(" ");
    var modifiedProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        className: classes
    });
    // Remove props so they don't appear in DOM
    delete modifiedProps.variant;
    delete modifiedProps.Tag;
    delete modifiedProps.font;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, modifiedProps), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Typo);


/***/ }),

/***/ 51091:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getCharacters = function(text, n) {
    var textWithoutUrls = text.replace(RegExp("\\(?<a.*?<\\/a>\\)?", "gi"), "");
    var pos = textWithoutUrls === null || textWithoutUrls === void 0 ? void 0 : textWithoutUrls.indexOf(" ", n);
    var out = textWithoutUrls === null || textWithoutUrls === void 0 ? void 0 : textWithoutUrls.substring(0, pos);
    return pos <= 0 ? text : out + "...";
};
/* harmony default export */ __webpack_exports__["Z"] = (getCharacters);


/***/ }),

/***/ 22028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SidebarLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./store/auth.js
var store_auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./styles/modules/SidebarNav.module.scss
var SidebarNav_module = __webpack_require__(36360);
var SidebarNav_module_default = /*#__PURE__*/__webpack_require__.n(SidebarNav_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Nav/NavigationLinks.js + 9 modules
var NavigationLinks = __webpack_require__(3616);
;// CONCATENATED MODULE: ./components/SidebarNav.js






var SidebarNav = function() {
    var router = (0,next_router.useRouter)();
    var auth = (0,es/* useSelector */.v9)(store_auth/* authSelector */.aF);
    if (!router.query.company && !auth.company) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: (SidebarNav_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationLinks/* default */.Z, {
            styles: (SidebarNav_module_default())
        })
    });
};
/* harmony default export */ var components_SidebarNav = (SidebarNav);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Svg/ArrowDown.js
var ArrowDown = __webpack_require__(87878);
// EXTERNAL MODULE: ./styles/modules/Breadcrumb.module.scss
var Breadcrumb_module = __webpack_require__(56992);
var Breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumb_module);
;// CONCATENATED MODULE: ./components/Nav/Breadcrumb.js






var Breadcrumb = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), links = ref[0], setLinks = ref[1];
    (0,react.useEffect)(function() {
        var paths = router.asPath.split("/").filter(Boolean);
        // paths.shift(); // used .filter(Boolean) instead
        var newPaths = [];
        paths.forEach(function(item, index) {
            newPaths.push("".concat(newPaths[index - 1] || "") + "/".concat(item));
        });
        setLinks(newPaths);
    }, []);
    // if (!router.query?.company) {
    //     return null;
    // }
    return (links === null || links === void 0 ? void 0 : links.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: [
            "mb-l",
            (Breadcrumb_module_default()).wrapper, 
        ].join(" "),
        children: links === null || links === void 0 ? void 0 : links.map(function(href, index) {
            var isLast = index === links.length - 1;
            var label;
            // index === 0
            //     ? 'Newspage'
            //     : href.split('/')[index + 1].replaceAll('-', ' ');
            if (index === 0) {
                if (router.asPath.includes("/news-story/")) {
                    label = "Newspage"; // TODO: Get company name instead
                } else {
                    label = "Newspage";
                }
            } else {
                label = href.split("/")[index + 1].replaceAll("-", " ");
            }
            var item;
            // if not last item, create a link
            if (!isLast) {
                item = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: href,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (Breadcrumb_module_default()).href,
                        children: label
                    })
                });
            } else {
                item = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Breadcrumb_module_default()).href,
                    children: label
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    item,
                    !isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                ]
            }, index);
        })
    });
};
/* harmony default export */ var Nav_Breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./styles/modules/SidebarLayout.module.scss
var SidebarLayout_module = __webpack_require__(89722);
var SidebarLayout_module_default = /*#__PURE__*/__webpack_require__.n(SidebarLayout_module);
;// CONCATENATED MODULE: ./layouts/SidebarLayout.js




function SidebarLayout(param) {
    var isAuthenticated = param.isAuthenticated, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            (SidebarLayout_module_default()).layout,
            !isAuthenticated ? (SidebarLayout_module_default()).lightBackground : "", 
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: [
                "container",
                (SidebarLayout_module_default()).container
            ].join(" "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    "row",
                    (SidebarLayout_module_default()).row
                ].join(" "),
                children: [
                    isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SidebarNav, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            "page",
                            (SidebarLayout_module_default()).body
                        ].join(" "),
                        children: [
                            isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Breadcrumb, {}),
                            children
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 4226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ breaking_news; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(5056);
// EXTERNAL MODULE: ./layouts/SidebarLayout.js + 2 modules
var SidebarLayout = __webpack_require__(22028);
// EXTERNAL MODULE: ./store/index.js
var store = __webpack_require__(23261);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./styles/modules/Feed.module.scss
var Feed_module = __webpack_require__(48972);
var Feed_module_default = /*#__PURE__*/__webpack_require__.n(Feed_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
// EXTERNAL MODULE: ./components/Card.js + 4 modules
var Card = __webpack_require__(83958);
// EXTERNAL MODULE: ./helpers/getCharacters.js
var getCharacters = __webpack_require__(51091);
// EXTERNAL MODULE: ./utils/tag-remove.js
var tag_remove = __webpack_require__(92131);
// EXTERNAL MODULE: ./components/NotFound.js
var NotFound = __webpack_require__(93086);
;// CONCATENATED MODULE: ./components/Feed/List.js













var resultsPerPage = 3;
var FeedList = function(param) {
    var data = param.data, type = param.type;
    var ref = (0,react.useState)(data), cardsToShow = ref[0], setCardsToShow = ref[1];
    var ref1 = (0,react.useState)(false), loadMoreActive = ref1[0], setLoadMoreActive = ref1[1];
    var ref2 = (0,react.useState)(resultsPerPage), next = ref2[0], setNext = ref2[1];
    var holdingResults = [];
    var loopWithSlice = function(end) {
        var slicedResults = data.slice(0, end);
        holdingResults = slicedResults ? (0,_to_consumable_array/* default */.Z)(slicedResults) : null;
        setCardsToShow(holdingResults);
        if (end >= data.length) {
            setLoadMoreActive(false);
        } else {
            setLoadMoreActive(true);
        }
    };
    (0,react.useEffect)(function() {
        loopWithSlice(resultsPerPage);
    }, []);
    var handleLoadMore = function() {
        var nextNum = next + resultsPerPage;
        loopWithSlice(nextNum);
        setNext(nextNum);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                variant: "h2",
                className: "styles.title",
                children: en/* feed */.LR["news_".concat(type)].title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Feed_module_default()).cardsWrapper,
                children: cardsToShow.length > 0 ? cardsToShow.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, (0,_object_spread/* default */.Z)({
                        id: item.id,
                        title: (0,getCharacters/* default */.Z)(item.title, 50),
                        body: (0,getCharacters/* default */.Z)((0,tag_remove/* default */.Z)(item.body), 120),
                        link: type === "story" ? "".concat(item.company.slug, "/news-story/").concat(item.slug) : "/news-alerts/".concat(item.slug),
                        publishedAt: item.publicationDate,
                        linkOverlay: true,
                        feed: true
                    }, type === "story" ? {
                        author: (0,_object_spread/* default */.Z)({}, item.expert ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.expert), {
                            slug: item.company.slug
                        }) : item.company)
                    } : {
                        alert: true
                    }), "card-item-".concat(item.id));
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* default */.Z, {
                    text: en/* feed */.LR["news_".concat(type)].no_news_alert
                })
            }),
            loadMoreActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Feed_module_default()).loadMore,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Load more",
                    onClick: handleLoadMore
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Feed_module_default()).divider
            })
        ]
    });
};
/* harmony default export */ var List = (FeedList);

;// CONCATENATED MODULE: ./pages/breaking-news.js











var Feed = function(param) {
    var data = param.data, _isAuthenticated = param.isAuthenticated, isAuthenticated = _isAuthenticated === void 0 ? false : _isAuthenticated;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z), {
                titleTemplate: "".concat(en/* feed.title */.LR.title, " | %s")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarLayout/* default */.Z, {
                isAuthenticated: isAuthenticated,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Feed_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Feed_module_default()).titleWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                                variant: "h1",
                                children: en/* feed.title */.LR.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Feed_module_default()).divider
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Feed_module_default()).listWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                    data: data.alerts,
                                    type: "alert"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                                    data: data.stories,
                                    type: "story"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var breaking_news = (store/* wrapper.withRedux */.Y.withRedux(Feed));


/***/ }),

/***/ 92131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ tagRemove; }
/* harmony export */ });
function tagRemove() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (data === null) {
        return "";
    }
    return data.replace(/(<([^>]+)>)/gi, "");
}


/***/ }),

/***/ 56992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__0Agi8","href":"Breadcrumb_href__Toawd"};

/***/ }),

/***/ 76136:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Card_cardWrapper__Ts5If","card":"Card_card__fBILh","card--add-button":"Card_card--add-button__VWyTM","card--add":"Card_card--add__W3FzD","addIcon":"Card_addIcon__Q_W7S","card--draft":"Card_card--draft__D97Ww","card__status":"Card_card__status__fLb7C","card__status--new":"Card_card__status--new__f1PHL","card__actions":"Card_card__actions__70_Wv","card__status--request-editing":"Card_card__status--request-editing__u7uOq","close":"Card_close__SqYus","button":"Card_button__xDhfQ","overlayLink":"Card_overlayLink__bA12D","action":"Card_action__tfgwc","title":"Card_title__gkvsT","body":"Card_body__3LyaM","wrapperCta":"Card_wrapperCta__1uidB","cta":"Card_cta__WPp6v","authorLink":"Card_authorLink__3Fd2O"};

/***/ }),

/***/ 48972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Feed_headerWrapper__gylth","titleWrapper":"Feed_titleWrapper__jSRR0","cardsWrapper":"Feed_cardsWrapper__Eo4Ug","listWrapper":"Feed_listWrapper__nzVP2","divider":"Feed_divider__PPzDJ","wrapper":"Feed_wrapper__dvKWT"};

/***/ }),

/***/ 89722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"SidebarLayout_layout__3iedG","container":"SidebarLayout_container__ojXS5","row":"SidebarLayout_row__LDQOd","body":"SidebarLayout_body__x7PlU","lightBackground":"SidebarLayout_lightBackground__kJ0gF"};

/***/ }),

/***/ 36360:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SidebarNav_wrapper__iWGk3","list":"SidebarNav_list__7bZP3","tooltip":"SidebarNav_tooltip__Soj6L","item":"SidebarNav_item__hRhK_","title":"SidebarNav_title__ZdCkY","active":"SidebarNav_active__J_l9i","notification":"SidebarNav_notification__sNqIG"};

/***/ }),

/***/ 61176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"typo--serif":"Typo_typo--serif__ahG_k","typo--h1":"Typo_typo--h1__k9d1d","typo--h2":"Typo_typo--h2__ERFQP","typo--h3":"Typo_typo--h3__96TzI","typo--perex":"Typo_typo--perex__jtAL0","typo--body":"Typo_typo--body__N8tZg","typo--small":"Typo_typo--small__IMpLY","typo--caption":"Typo_typo--caption__BQ_Ci","typo--special":"Typo_typo--special__PCh7S","typo--quote":"Typo_typo--quote__kbLSb","typo--quote-author":"Typo_typo--quote-author__gGzSj"};

/***/ }),

/***/ 73736:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"Index_titleWrapper__piWmT","storiesWrapper":"Index_storiesWrapper__FA_eW","title":"Index_title__lLBdw","divider":"Index_divider__DeLoc","button":"Index_button__Dv4cR","cardsWrapper":"Index_cardsWrapper__ownti","noStoryBlock":"Index_noStoryBlock__BoEDD","wrapper":"Index_wrapper__vbQZH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(28790); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);